module.exports = __webpack_public_path__ + "img/sala-branco.e3add1c2.svg";